import { Locale } from '@backmarket/http-api'

enum Language {
  FRENCH = 'FRENCH',
  ENGLISH = 'ENGLISH',
}

interface ExternalLinkListByCountryList {
  [Language.FRENCH]: ExternalLinkList
  [Language.ENGLISH]: ExternalLinkList
}

interface ExternalLinkList {
  API_DOC_LINK: string
  SUPPORT_CENTER_LINK: string
  WHAT_IS_BACKCARE_LINK: string
  AESTHETIC_GRADES_SUPPORT_LINK: string
  WHAT_IS_BACKSHIP_LINK: string
  LEARN_MORE_ABOUT_BACKCARE_LINK: string
  HOW_TO_USE_BACKPRICER_LINK: string
  HOW_TO_SET_UP_SHIPPING_METHODS_LINK: string
  TERMS_AND_CONDITIONS_LINK: string
  QUALITY_CHARTER_LINK: string
  HOW_TO_FILL_IMEI_LINKS: string
  WHAT_IS_HYPERWALLET_LINK: string
  WHAT_IS_CCBM_LINK: string
  BACKPACK_LINK: string
  DEFERRED_PAYOUT_LINKS: string
  NEW_BATTERY_OFFER_LINK: string
  ACTIVATION_LINK: string
}

const globalExternalLinkList: ExternalLinkListByCountryList = {
  [Language.FRENCH]: {
    API_DOC_LINK: 'https://doc.backmarket.fr/',
    SUPPORT_CENTER_LINK: 'https://backmarket.my.site.com/ssc/s/',
    WHAT_IS_BACKCARE_LINK:
      'https://backmarket.my.site.com/ssc/s/article/BackCare-Qu-est-ce-que-le-BackCare',
    AESTHETIC_GRADES_SUPPORT_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Passage-à-3-Grades-clients',
    WHAT_IS_BACKSHIP_LINK:
      'https://backmarket.my.site.com/ssc/s/topic/0TO3X000000xTEtWAM/backship',
    LEARN_MORE_ABOUT_BACKCARE_LINK:
      'https://backmarket.my.site.com/ssc/s/topic/0TO3X000000xTEuWAM/backcare',
    HOW_TO_USE_BACKPRICER_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Comment-utiliser-le-BackPricer',
    HOW_TO_SET_UP_SHIPPING_METHODS_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Configurer-mes-m%C3%A9thodes-de-livraison',
    TERMS_AND_CONDITIONS_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Conditions-Générales-Vendeurs',
    QUALITY_CHARTER_LINK:
      'https://backmarket.my.site.com/ssc/s/article/R%C3%A9sum%C3%A9-de-la-Politique-Qualit%C3%A9-de-Back-Market',
    HOW_TO_FILL_IMEI_LINKS:
      'https://backmarket.my.site.com/ssc/s/article/Comment-renseigner-l-IMEI-Numéro-de-série',
    WHAT_IS_HYPERWALLET_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Upgrade-your-Back-Market-account-with-HyperWallet',
    WHAT_IS_CCBM_LINK:
      'https://backmarket.my.site.com/ssc/s/topic/0TO3X000000HnHkWAK/ccbm-customer-care-by-back-market',
    BACKPACK_LINK: 'https://backpack.backmarket.com/fr',
    DEFERRED_PAYOUT_LINKS:
      'https://backmarket.my.site.com/ssc/s/article/D%C3%A9p%C3%B4t-de-garantie',
    NEW_BATTERY_OFFER_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Information-sur-l-offre-de-smartphones-avec-une-batterie-neuve',
    ACTIVATION_LINK:
      'https://backmarket.my.site.com/ssc/s/topic/0TOSb0000000HYjOAM/activation-phase',
  },
  [Language.ENGLISH]: {
    API_DOC_LINK: 'https://doc.backmarket.fr/',
    SUPPORT_CENTER_LINK: 'https://backmarket.my.site.com/ssc/s/',
    WHAT_IS_BACKCARE_LINK:
      'https://backmarket.my.site.com/ssc/s/article/BackCare-What-is-the-BackCare-Service',
    AESTHETIC_GRADES_SUPPORT_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Moving-to-3-Customer-Grades',
    WHAT_IS_BACKSHIP_LINK:
      'https://backmarket.my.site.com/ssc/s/topic/0TO3X000000xTEtWAM/backship',
    LEARN_MORE_ABOUT_BACKCARE_LINK:
      'https://backmarket.my.site.com/ssc/s/topic/0TO3X000000xTEuWAM/backcare',
    HOW_TO_USE_BACKPRICER_LINK:
      'https://backmarket.my.site.com/ssc/s/article/How-to-use-BackPricer',
    HOW_TO_SET_UP_SHIPPING_METHODS_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Set-up-my-shipping-methods',
    TERMS_AND_CONDITIONS_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Terms-and-Conditions',
    QUALITY_CHARTER_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Back-Market-Quality-Policy-Summary',
    HOW_TO_FILL_IMEI_LINKS:
      'https://backmarket.my.site.com/ssc/s/article/Comment-renseigner-l-IMEI-Numéro-de-série',
    WHAT_IS_HYPERWALLET_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Upgrade-your-Back-Market-account-with-HyperWallet',
    WHAT_IS_CCBM_LINK:
      'https://backmarket.my.site.com/ssc/s/topic/0TO3X000000HnHkWAK/ccbm-customer-care-by-back-market',
    BACKPACK_LINK: 'https://backpack.backmarket.com/',
    DEFERRED_PAYOUT_LINKS:
      'https://backmarket.my.site.com/ssc/s/article/Deferred-Payout',
    NEW_BATTERY_OFFER_LINK:
      'https://backmarket.my.site.com/ssc/s/article/Information-on-the-New-Battery-offer',
    ACTIVATION_LINK:
      'https://backmarket.my.site.com/ssc/s/topic/0TOSb0000000HYjOAM/activation-phase',
  },
}

const getExternalLinksLanguage = (locale: Locale) =>
  [Locale.fr_FR, Locale.fr_BE].includes(locale)
    ? Language.FRENCH
    : Language.ENGLISH

export const getExternalLinkList = (locale: Locale) => {
  const linkListLanguage = getExternalLinksLanguage(locale)

  return globalExternalLinkList[linkListLanguage]
}
